import { useQuery } from '@tanstack/react-query';

import { api } from '@starling/core/api/client';
import type { components } from '@/api/types.gen';

export type AppFeatures = components['schemas']['AppFeatures'];

export const LIGHT_FEATURES_KEY = ['apps', 'features', 'light'] as const;

/**
 * Публичные фича-флаги Light (`GET /apps/light/features`, без токена) —
 * доводка V1 №19: platform_admin включает/выключает раздел «Объявления» в
 * кабинете оптики («Настройки» → «Приложения»). Читают сайдбар и гард
 * маршрута `/listings`. Fail-open: пока флаги не загрузились или запрос упал,
 * раздел считается включённым (это видимость, не безопасность — бэкенд
 * данными Vision всё равно отвечает).
 */
export function useLightFeaturesQuery() {
  return useQuery({
    queryKey: LIGHT_FEATURES_KEY,
    queryFn: () => api.get<AppFeatures>('/api/v1/apps/light/features', { skipAuth: true }),
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });
}

export function useListingsEnabled(): boolean {
  const { data } = useLightFeaturesQuery();
  return data?.listings_enabled ?? true;
}
